export default "<ion-checkbox slot=\"start\" class=\"me-2\" [(ngModel)]=\"isChecked\" (ionChange)=\"change()\" (click)=\"onClick($event)\"></ion-checkbox>\n";